import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';
import { TaskService } from '../../services/task.service';
import { Router } from '@angular/router';
import { Notification } from '../../models/notifications-toast.model';
import { generateClient } from 'aws-amplify/api';
import { type Schema } from '../../../../../amplify/data/resource';


@Component({
  selector: 'app-notification-bell',
  imports: [CommonModule],
  templateUrl: './notification-bell.html'
})
export class NotificationBellComponent {
  private router = inject(Router);
  private taskService = inject(TaskService);
  notificationService = inject(NotificationService);
  private client = generateClient<Schema>();

  isOpen = false;

  /** Close the panel when clicking anywhere outside this component. */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.isOpen) return;
    const target = event.target as HTMLElement;
    if (!target.closest('app-notification-bell')) {
      this.isOpen = false;
    }
  }

  async markRead(notif: Notification) {
    try {
      if (!notif.isRead) await this.notificationService.markAsRead(notif.id);

      if (notif.todoId) {
        // Todo assignment → navigate to the Todos page with the todoId
        this.router.navigate(['/todos'], { queryParams: { todoId: notif.todoId } });
      } else if (notif.projectId && notif.taskId) {
        // Task with known project → open the task directly
        this.router.navigate(['/projects', notif.projectId], { queryParams: { taskId: notif.taskId } });
      } else if (notif.taskId) {
        // Task without projectId → resolve project from the task's stage
        const projectId = await this.resolveProjectIdFromTask(notif.taskId);
        if (projectId) {
          this.router.navigate(['/projects', projectId], { queryParams: { taskId: notif.taskId } });
        } else {
          this.router.navigate(['/dashboard']);
        }
      } else if (notif.projectId) {
        this.router.navigate(['/projects', notif.projectId]);
      } else if (notif.content?.toLowerCase().includes('todo')) {
        this.router.navigate(['/todos']);
      } else {
        this.notificationService.showToast('Cannot navigate to this notification', 'info');
      }
    } catch (err) {
      console.error('Error handling notification click', err);
    } finally {
      this.isOpen = false;
    }
  }

  /** Resolve the projectId from a task by looking up its stage. */
  private async resolveProjectIdFromTask(taskId: string): Promise<string | null> {
    try {
      const task = await this.taskService.getTaskById(taskId);
      if (!task?.projectStageId) return null;
      const { data: stage } = await this.client.models.ProjectStage.get({ id: task.projectStageId });
      return stage?.projectId ?? null;
    } catch {
      return null;
    }
  }
}
